const CHNCode = 'CN'; //中国地区编码  对应区域表
//海宁经编的应用code
const applicationCode = [
  '2019112814172680887', //物产化工
  '2020091409450974746', // 客户供应商
];
const dataGroup = 'zjmi'; //zjmi物产化工  hn海宁经编
const subserver = {
  name: 'HN',
  interface: 'hn',
  companyCode: '70J0',
  companyName: '浙江物产经编供应链有限公司',
  departmentCode: '70J1',
  departmentName: '客户服务部',
  dataGroup: 'hn', //zjmi物产化工  hn海宁经编
};
const currency = {
  code: 'CNY',
  name: '中国人民币（国际）',
  forgeinCode: 'USD',
  forgeinName: '美元',
};

const refreshTokenFlag = 0; //标记是否调用刷新token接口，防止重复调用问题

const pPoint = 6; //pricePoint单价精度
const aPoint = 2; //amountPoint金额精度
const qPoint = 4; //quantityPoint数量精度
const ePoint = 10; //exchangeRatePoint汇率精度
const dPoint = 0; //dayPoint天数精度
const iPoint = 6; //interestRatePoint利率(比例)精度
const tPoint = 2; //taxRatePoint税率精度

export default {
  CHNCode,
  subserver,
  currency,
  applicationCode,
  dataGroup,
  pPoint,
  aPoint,
  qPoint,
  ePoint,
  dPoint,
  iPoint,
  tPoint,
  refreshTokenFlag,
};
